<template>
  <div>
    <custom-callout
      class="mb-3 custom-callout"
      :opened="item.isOpen"
      :controlled="true"
      :border-color="item.statusColor"
      @click:open="onToggle()"
    >
      <div class="row border-bottom py-3 m-0">
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Número de Referido:
          </div>
          <div class="color-black font-16 font-weight-bold">
            {{ item.referralNumber | empty }}
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Número de Requisición:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.requisitionNumber | empty }}
          </div>
        </div>
        <div class="col-md-4 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Estudiante:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.studentName | empty }}
          </div>
        </div>
        <div class="col">
          <drop-down :items="actionItems" class="float-md-right mr-5" />
        </div>
      </div>
      <div class="row py-3 m-0">
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal">
            Estatus:
          </div>
          <div class="mt-2 d-flex align-items-center">
            <div
              class="status-balloon-container w-unset"
              :style="{ 'background-color': item.statusColor }"
            ></div>
            <span class="font-weight-bold">{{ item.statusName | empty }}</span>
          </div>
        </div>
        <div class="col-sm col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Tipo de Referido:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.referralTypeName | empty }}
          </div>
        </div>
        <div class="col-sm col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Fecha de Referido:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.referralDate | date }}
          </div>
        </div>
        <div class="col-sm col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Fecha de Requisición:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ item.requisitionDate | date }}
          </div>
        </div>
      </div>
      <template #edition>
        <div class="bg-light-gray p-2">
          <div class="bg-white py-3 px-md-3 rounded" v-if="showTabs">
            <requisition-managment-tabs :item="item" :tab-index="0" />
          </div>
          <div class="mt-md-4">
            <add-binnacle
              v-if="showAddBinnacle"
              v-model="model.binnacle"
              @cancel="handlerCloseAddBinnacle"
              @save="handlerAddBinnacle"
            />
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import DropDown from 'dropdown';
import mixAlert from '@/mixins/alert.mixin';
import { serialize as objectToFormData } from 'object-to-formdata';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import AddBinnacle from '../../referralAndEquipment/components/AddBinnacle.vue';
import RequisitionManagmentTabs from './RequisitionManagmentTabs.vue';

const TEMPLATE_TAB_INDEX = {
  TABS: 0,
  ADDBINNACLE: 1,
};

const REQUISITION_MANAGEMENT_DETAIL_ROUTE_NAME = 'RequisitionManagementDetail';

export default {
  name: 'RequisitionManagementResultRow',
  components: {
    CustomCallout,
    DropDown,
    ActionButton,
    AddBinnacle,
    RequisitionManagmentTabs,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    selectedTemplateTabIndex: null,
    model: {
      binnacle: {
        attachment: null,
        attachmentId: null,
        comment: null,
        documentName: null,
      },
    },
  }),
  computed: {
    actionItems() {
      return [
        {
          name: 'Añadir Bitácora',
          icon: 'far fa-comment text-green',
          border: 'bottom',
          click: () => this.handlerOpenAddBinnacle(),
        },
        {
          name: 'Requisición ',
          icon: 'far fa-retweet-alt text-success',
          click: () => this.handlerGoToDetail(),
        },
      ];
    },
    showAddBinnacle() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.ADDBINNACLE;
    },
    showTabs() {
      return this.selectedTemplateTabIndex == TEMPLATE_TAB_INDEX.TABS;
    },
  },
  methods: {
    async onToggle() {
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.TABS;

      if (this.item.isOpen) {
        this.$emit('close', this.item);
        return;
      }
      this.$emit('open', this.item);
    },
    handlerOpenAddBinnacle() {
      this.$emit('open', this.item);
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.ADDBINNACLE;
    },
    handlerCloseAddBinnacle() {
      this.selectedTemplateTabIndex = null;
      this.model.binnacle = {
        attachment: null,
        attachmentId: null,
        comment: null,
        documentName: null,
      };
      this.$emit('close', this.item);
    },
    async handlerAddBinnacle() {
      const payload = objectToFormData({
        ...this.model.binnacle,
        peiAtServiceId: this.item.id,
        peiAtServiceRequisitionId: this.item.requisitionId,
      });

      const { data } = await referralAndEquipmentsservice
        .saveBinnacle(payload)
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        });
      if (data) {
        this.model.binnacle = {
          attachment: null,
          attachmentId: null,
          comment: null,
          documentName: null,
        };
        this.ShowToast(
          'Éxito',
          'Se ha guardado la bitácora correctamente',
          'success'
        );
      }
      this.handlerCloseAddBinnacle();
    },
    handlerGoToDetail() {
      this.$router.push({
        name: REQUISITION_MANAGEMENT_DETAIL_ROUTE_NAME,
        params: {
          peiAtServiceId: this.item.id,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.status-balloon-container {
  margin-right: 10px;
  padding: 5px;
  text-align: center;
  color: #11291b;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 900;
  width: 100%;
  width: unset;
}
</style>
